/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable react/button-has-type */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { IconButton } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { LoadingButton } from '@mui/lab';
import { StatusChip, ScopeChip } from '../shared/SharedComponents';
import { EditLockedModal, CannotDeleteModal, DeletePlanModal } from '../listing/ListingComponents';
import AddAssessmentModal from './AddAssessmentModal';
import AddCourseModal from './AddCourseModal';
import subscriptionServices from '../../../../../services/subscriptionServices';

const MetricCard = ({ label, value }) => (
  <div className="flex-1 bg-white border border-gray-200 rounded-[10px] px-5 py-4">
    <p className="text-[12px] text-gray-400 mb-[6px]">{label}</p>
    <p className="text-[22px] font-bold text-gray-900">{value}</p>
  </div>
);

const DetailRow = ({ label, value, copyable, mono }) => {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <div>
      <p className="text-[12px] text-gray-400 mb-1">{label}</p>
      <div className="flex items-center gap-[6px]">
        <p className={`text-[14px] font-semibold ${value ? 'text-gray-900' : 'text-gray-400'} ${mono ? 'font-mono' : ''}`}>
          {value || '—'}
        </p>
        {copyable && value && (
          <IconButton size="small" onClick={handleCopy} sx={{ p: '2px', color: copied ? '#2563eb' : '#9ca3af' }}>
            <ContentCopyIcon sx={{ fontSize: '13px' }} />
          </IconButton>
        )}
      </div>
    </div>
  );
};

export const OverviewTab = ({ plan, planType, planStatus, onEdit, onToggleStatus, toggling, onDelete }) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showCannotDelete, setShowCannotDelete] = useState(false);
  const [showEditLocked, setShowEditLocked] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [movingToDraft, setMovingToDraft] = useState(false);

  // DEBUG: confirms what planStatus this component actually received from PlanDetail.js.
  // Remove once the upstream calculation in PlanDetail.js is confirmed correct.
  // console.log('planStatus received:', planStatus, 'plan.isActive:', plan?.isActive, 'plan.isOnline:', plan?.isOnline);
  console.log(plan,"planplan");
  

  const isDeleted =  false;
  // planStatus === 'deleted';
  const isLive = plan?.isOnline 
  // planStatus === 'published';
  const isDraft = !plan?.isOnline || !plan?.isActive
  console.log(isDraft,"isDraft");
  
  // planStatus === 'draft';
  const isBundle = planType === 'bundle';
  const isB2B = planType === 'b2b';

  const handleEditClick = () => {
    if (isLive) {
      setShowEditLocked(true);
      return;
    }
    onEdit();
  };

  const handleMoveToDraftAndEdit = async () => {
    setMovingToDraft(true);
    try {
      await onToggleStatus?.();
      setShowEditLocked(false);
      onEdit();
    } finally {
      setMovingToDraft(false);
    }
  };

  const handleDeleteClick = () => {
    const subCount = plan?.subscriberCount ?? plan?.tenantCount ?? 0;
    if (subCount > 0) {
      setShowCannotDelete(true);
    } else {
      setShowDeleteConfirm(true);
    }
  };

  const handleConfirmDelete = async () => {
    setDeleting(true);
    try {
      await onDelete?.(plan);
    } finally {
      setDeleting(false);
      setShowDeleteConfirm(false);
    }
  };

  const scope = (() => {
    if (plan?.scope === 'category') return `Category Bundle${plan?.category ? ` — ${plan.category}` : ''}`;
    if (plan?.scope === 'platform' || isB2B) return 'Platform-wide';
    const name = (plan?.subscriptionPlan?.name || '').toLowerCase();
    if (name.includes('category')) return `Category Bundle${plan?.category ? ` — ${plan.category}` : ''}`;
    return 'Platform-wide';
  })();

  const isCategory = scope.includes('Category');

  const metricLabel2 = isBundle ? 'Annual Revenue' : 'MRR';
  const metricValue2 = (() => {
    const v = plan?.mrr ?? plan?.annualRevenue ?? 0;
    return `₹${Number(v).toLocaleString('en-IN')}`;
  })();

  const priceLabel = isBundle ? 'Price (₹/year)' : 'Price';

  const subscriptionName = (plan?.subscriptionInfo?.name || '').toLowerCase();
  const billingCycle = (plan?.billingCycle || '').toLowerCase();
  const isYearly = billingCycle === 'yearly' || subscriptionName.includes('yearly');
  const duration = isYearly ? '/yr' : '/mo';

  const priceValue = (() => {
    if (isB2B) return 'Via contract';
    const inrPrice = plan?.prices?.find(p => p?.currencyType?.code === 'INR')?.actualCost ?? plan?.payableCost;
    const usdPrice = plan?.prices?.find(p => p?.currencyType?.code === 'USD')?.actualCost;
    const hasInr = inrPrice && Number(inrPrice) > 0;
    const hasUsd = usdPrice && Number(usdPrice) > 0;
    if (!hasInr && !hasUsd) return 'Free';
    if (hasInr && hasUsd) {
      return `$${usdPrice}${duration} (₹${Number(inrPrice).toLocaleString('en-IN')}${duration})`;
    }
    if (hasUsd) return `$${usdPrice}${duration}`;
    return `₹${Number(inrPrice).toLocaleString('en-IN')}${duration}`;
  })();

  const detailRows = (() => {
    const base = [
      { label: 'Plan name', value: plan?.name },
      { label: 'Scope', value: scope },
    ];
    if (planType === 'single' || planType === 'bundle') {
      base.push({ label: 'Display name', value: plan?.displayName });
      base.push({ label: 'Description', value: plan?.description });
    } else {
      base.push({ label: 'Description', value: plan?.description });
      if (planType !== 'b2b' && plan?.tier !== 'FREE') {
      base.push({
        label: 'Billing cycle',
        value: plan?.subscriptionInfo?.durationType?.description || plan?.billingCycle || 'Monthly',
      });
      }
    }
    if (planType === 'bundle') {
      base.push({ label: 'Billing cycle', value: plan?.billingCycle || 'Annual' });
    }
  // if (planType === 'bundle') {
  //     base.push({ label: 'Billing cycle', value: plan?.billingCycle || 'Annual' });
  //   }
    if (planType !== 'b2b' && planType !== 'single' && planType !== 'bundle') {
      base.push({
        label: 'Max paid attempts',
        value: plan?.maxAttempts ? `${plan.maxAttempts} per assessment` : '5 per assessment',
      });
    }
    base.push({
      label: 'Created',
      value: plan?.createdDate
        ? new Date(plan.createdDate).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
        : '—',
    });
    if (planType !== 'b2b' && plan?.isPaid !== 'Free') {
      base.push({ label: 'Stripe Product ID', value: plan?.stripeProductId, copyable: true, mono: true });
    }
    return base;
  })();

  return (
    <>
      {isDraft && (
        <div className="flex items-start gap-3 bg-amber-50 border border-amber-200 rounded-[10px] px-5 py-[13px] mb-5">
          <WarningAmberOutlinedIcon sx={{ fontSize: '16px', color: '#d97706', mt: '1px', flexShrink: 0 }} />
          <p className="text-[13px] text-amber-800 leading-snug">
            This plan is in draft. Existing subscribers retain access until their billing period ends.
            New users cannot subscribe until the plan is set live again.
          </p>
        </div>
      )}

      <div className="flex items-center justify-between bg-white border border-gray-200 rounded-[10px] px-5 py-[14px] mb-5 flex-wrap gap-3">
        <div className="flex items-center gap-2 flex-wrap">
          <StatusChip status={(plan?.isOnline  === true && plan?.isActive  === true ) ? 'published': 'draft'} />
          <ScopeChip label={isCategory ? 'Category Bundle' : 'Platform-wide'} color={isCategory ? 'purple' : 'blue'} />
          {isBundle && <ScopeChip label="Course Bundle" color="green" />}
          {!isB2B && (
          <ScopeChip
            label={ plan?.isPaid === 'Free' ? 'Free' : 'Paid'}
            color={ plan?.isPaid === 'Free' ? 'green' : 'indigo'}
          />
          )}
        </div>

        {isDeleted ? (
          <p className="text-[13px] text-gray-400 italic">This plan has been deleted.</p>
        ) : (
          <div className="flex items-center gap-[10px] flex-wrap">
            <button
              onClick={handleEditClick}
              className="flex items-center gap-[6px] bg-white border border-gray-300 rounded-[7px] px-[14px] py-[7px] text-[13px] font-medium text-gray-700 cursor-pointer hover:bg-gray-50"
            >
              <EditOutlinedIcon sx={{ fontSize: '15px' }} /> Edit Details
            </button>

            {isDraft && (
              <LoadingButton
                loading={toggling}
                onClick={onToggleStatus}
                sx={{
                  fontSize: '13px', fontWeight: 600, color: '#fff',
                  background: '#2563eb', borderRadius: '7px', textTransform: 'none',
                  px: '14px', py: '7px',
                  '&:hover': { background: '#1d4ed8' },
                }}
              >
                Set Live
              </LoadingButton>
          )} 

            {isDraft && (
              <button
                onClick={handleDeleteClick}
                className="flex items-center gap-[6px] bg-white border border-red-300 rounded-[7px] px-[14px] py-[7px] text-[13px] font-medium text-red-600 cursor-pointer hover:bg-red-50 transition-colors"
              >
                <DeleteOutlineIcon sx={{ fontSize: '15px' }} />
                Delete Plan
              </button>
             )} 
          </div>
        )}
      </div>

      {/* Metrics */}
      <div className="flex gap-[14px] mb-5 flex-wrap">
        <MetricCard label={isB2B ? 'Tenants' : 'Subscribers'} value={isB2B ? (plan?.tenantCount ?? 0) : (plan?.subscriberCount ?? 0)} />
        { plan?.isPaid !== 'Free' && <MetricCard label={metricLabel2} value={metricValue2} /> }
        <MetricCard label={priceLabel} value={priceValue} />
      </div>

      {/* Plan details card */}
      <div className="bg-white border border-gray-200 rounded-[10px] p-6">
        <p className="text-[11px] font-bold text-gray-400 tracking-[0.08em] uppercase mb-5">Plan Details</p>
        <div className="grid grid-cols-2 gap-6">
          {detailRows.map((row) => (
            <DetailRow key={row.label} {...row} />
          ))}
        </div>
        {!plan?.stripeProductId && planType !== 'b2b' && plan?.isPaid !== 'Free' && (
          <p className="text-[12px] text-gray-400 italic mt-4">— available after publishing</p>
        )}
        {plan?.stripeProductId && (
          <p className="text-[11px] text-gray-400 mt-2">Simulated — production connects to live Stripe</p>
        )}
      </div>

      <EditLockedModal
        open={showEditLocked && isLive && !movingToDraft}
        onClose={() => setShowEditLocked(false)}
        onMoveToDraftAndEdit={handleMoveToDraftAndEdit}
        moving={movingToDraft}
      />
      <CannotDeleteModal
        open={showCannotDelete}
        onClose={() => setShowCannotDelete(false)}
        subscriberCount={plan?.subscriberCount ?? plan?.tenantCount ?? 0}
      />
      <DeletePlanModal
        open={showDeleteConfirm}
        planName={plan?.name}
        onCancel={() => setShowDeleteConfirm(false)}
        onConfirm={handleConfirmDelete}
        deleting={deleting}
      />
    </>
  );
};

const LiveChip = () => (
  <span className="inline-flex items-center h-5 text-[10px] font-bold rounded-full px-2 bg-green-100 text-green-800 border border-green-300">
    LIVE
  </span>
);

const InPlansChip = ({ count }) => (
  <span className="inline-flex items-center h-5 text-[10px] font-semibold rounded-full px-2 bg-amber-50 text-amber-800 border border-amber-300 gap-1">
    <span className="text-[12px]">⚠</span> In {count} plans
  </span>
);

const ContentTable = ({ columns, rows, onDelete ,isDeleted}) => (
  <div className="border border-gray-200 rounded-lg overflow-hidden">
    {/* Header */}
    <div
      className="bg-gray-50 px-4 py-[10px] border-b border-gray-200"
      style={{ display: 'grid', gridTemplateColumns: `${columns.map((c) => c.width || '1fr').join(' ')} 40px` }}
    >
      {columns.map((c) => (
        <p key={c.key} className="text-[11px] font-semibold text-gray-500 uppercase tracking-[0.06em] text-left">
          {c.label}
        </p>
      ))}
      <div />
    </div>

    {/* Rows */}
    {rows.length === 0 ? (
      <div className="flex flex-col items-center py-12 gap-2">
        <InsertDriveFileOutlinedIcon sx={{ fontSize: '32px', color: '#d1d5db' }} />
        <p className="text-[13px] text-gray-400">No items added to this plan yet.</p>
      </div>
    ) : (
      rows.map((row, idx) => (
        <div
          key={row.id || idx}
          className="px-4 py-[13px] items-center hover:bg-gray-50"
          style={{
            display: 'grid',
            gridTemplateColumns: `${columns.map((c) => c.width || '1fr').join(' ')} 40px`,
            borderBottom: idx < rows.length - 1 ? '1px solid #f3f4f6' : 'none',
          }}
        >
          {columns.map((c) => (
            <div key={c.key} className="flex items-center">
              {c.render ? c.render(row) : (
                <p className="text-[13px] text-gray-700">{row[c.key] || '—'}</p>
              )}
            </div>
          ))}
          <div className="flex items-center justify-end">
             {!isDeleted && (
            <IconButton size="small" onClick={() => onDelete(row)} sx={{ color: '#d1d5db', '&:hover': { color: '#ef4444' } }}>
              <DeleteOutlineIcon sx={{ fontSize: '16px' }} />
            </IconButton>
             )}
          </div>
        </div>
      ))
    )}
  </div>
);
 const DeleteConfirmModal = ({ open, itemName, type, onCancel, onConfirm }) => {
    if (!open) return null;

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
        <div className="bg-white rounded-[12px] shadow-xl w-full max-w-[420px] px-8 py-7">
          {/* Icon + Title */}
          <div className="flex items-center gap-3 mb-3">
            <span className="text-amber-500 text-[22px]">⚠</span>
            <p className="text-[16px] font-semibold text-gray-900">
              Remove {type} from plan?
            </p>
          </div>

          {/* Description */}
          <p className="text-[13px] text-gray-500 mb-6">
            Removing <span className="font-medium text-gray-700">"{itemName}"</span> will
            revoke learner access to this {type} for all subscribers of this plan.
          </p>

          {/* Buttons */}
          <div className="flex justify-end gap-3">
            <button
              onClick={onCancel}
              className="px-5 py-2 rounded-[7px] border border-gray-300 text-[13px] font-medium text-gray-700 bg-white hover:bg-gray-50 cursor-pointer">
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="px-5 py-2 rounded-[7px] border-none text-[13px] font-semibold text-white bg-red-600 hover:bg-red-700 cursor-pointer">
              Remove
            </button>
          </div>
        </div>
    </div>
  );
};

export const ContentTab = ({ plan, planType, assessmentFetchFn, courseFetchFn, onAddAssessment, onAddCourse, onDeleteAssessment, onDeleteCourse, planStatus }) => {
  const [addAssessmentOpen, setAddAssessmentOpen] = useState(false);
  const [addCourseOpen, setAddCourseOpen] = useState(false);
  const allAssessments = plan?.assessments || plan?.assessmentDetils || [];
 const allCourses = plan?.courseDetailsNew || plan?.courses || [];
  const [deleteTarget, setDeleteTarget] = useState(null);
  const existingAssessmentIds = allAssessments.map((a) => a.id);
  const existingCourseIds = allCourses.map((c) => c.id);

  const [selectedAssessmentIds, setSelectedAssessmentIds] = useState(existingAssessmentIds);
  const [selectedCourseIds, setSelectedCourseIds] = useState(existingCourseIds);
  const initializedRef = React.useRef(false);
  const isDeleted = false
  //  planStatus === 'deleted';
  const subscriptionTypeCode = (plan?.subscriptionType?.code || 'B2C').toUpperCase();
  const audienceIds = subscriptionTypeCode === 'B2B' ? ['B2B', 'BOTH'] : ['B2C', 'BOTH'];
  const [usedCourseIds, setUsedCourseIds] = useState([]);

  const fetchUsedCourseIds = async () => {
    try {
      const res = await subscriptionServices.getSubscriptionPlans({ planCategory: 'single', pageSize: 1000 });
      if (res.ok) {
        const ids = (res.data?.rows || [])
          .flatMap(p => (p.courseDetails || []).map(c => c.id))
          .filter(Boolean);
        setUsedCourseIds(ids);
      }
    } catch (e) {
      console.error('[fetchUsedCourseIds]', e);
    }
  };

  useEffect(() => {
    fetchUsedCourseIds();
  }, []);

  useEffect(() => {
    if (!initializedRef.current) {
      initializedRef.current = true;
      return;
    }
    // if (existingCourseIds.length > selectedCourseIds.length) {
        setSelectedAssessmentIds(existingAssessmentIds);

      setSelectedCourseIds(existingCourseIds);
    // }
}, [plan?.assessments, plan?.courseDetailsNew, plan?.assessmentDetils]);

  const assessments = allAssessments && allAssessments?.filter((a) => selectedAssessmentIds?.includes(a.id));
  const courses = allCourses && allCourses?.filter((c) => selectedCourseIds?.includes(c.id));

  const handleAddAssessment = (newIds) => {
    setSelectedAssessmentIds((prev) => [...new Set([...prev, ...newIds])]);
    if (onAddAssessment) onAddAssessment(newIds);
  };

  const handleDeleteAssessment = (item) => {
    setSelectedAssessmentIds((prev) => prev.filter((id) => id !== item.id));
  };

 const handleAddCourse = (newIds) => {
    setSelectedCourseIds((prev) => [...new Set([...prev, ...newIds])]);
    if (onAddCourse) onAddCourse(newIds);
  };

const handleDeleteCourse = (item) => {
    setSelectedCourseIds((prev) => prev.filter((id) => Number(id) !== Number(item.id)));
  };

  const confirmDelete = async () => {
    const target = deleteTarget;
    setDeleteTarget(null);
    if (target?.type === 'course') {
      await onDeleteCourse?.(target.item);
    } else if (target?.type === 'assessment') {
      await onDeleteAssessment?.(target.item);
    }
  };

const showAssessments = ['assessment', 'b2b'].includes(planType);
const showCourses = ['single', 'bundle', 'b2b'].includes(planType);
const isSingleCourse = planType === 'single';

const assessmentColumns = [
  {
    key: 'title', label: 'Title', width: '2fr',
    render: (row) => (
      <div className="flex items-center gap-2 flex-wrap">
                <p className="text-[13px] font-medium text-gray-900">{row.title || row.chapter_description} {row.internaltitle && (
                                                            <span className="ml-1 text-gray-500">({row.internaltitle})</span>
                                                        )}</p>
        {row.planCount > 1 && <InPlansChip count={row.planCount} />}
      </div>
    ),
  },
  { 
    key: 'category', label: 'Category', width: '1fr', 
    render: (row) => <p className="text-[13px] text-gray-700">{row.assessmentType || '-'}</p> 
  },
  { 
    key: 'type', label: 'Type', width: '1fr', 
    render: (row) => <p className="text-[13px] text-gray-700">{row.assessmentSubType || row.assessmentType || '—'}</p> 
  },
 { 
  key: 'status', label: 'Status', width: '100px',
  render: () => <LiveChip />,
},
];

  const courseColumns = [
    { key: 'title', label: 'Title', width: '2fr', render: (row) => <p className="text-[13px] font-medium text-gray-900">{row.title}</p> },
    { key: 'type', label: 'Type', width: '1fr', render: (row) => <p className="text-[13px] text-gray-700">{row.courseType || 'VIDEO'}</p> },
    { key: 'status', label: 'Status', width: '80px', render: () => <LiveChip /> },
  ];

 const ContentEmptyState = ({ message }) => (
    <div className="border border-gray-200 rounded-lg flex flex-col items-center py-12 gap-2">
      <InsertDriveFileOutlinedIcon sx={{ fontSize: '32px', color: '#d1d5db' }} />
      <p className="text-[13px] text-gray-400">{message}</p>
    </div>
  );

  return (
    <>
      {/* Plan audience */}
      <div className="flex items-center gap-2 mb-5">
        <p className="text-[13px] text-gray-500">Plan audience:</p>
        {planType === 'b2b' ? (
          <span className="inline-flex items-center h-5 text-[11px] font-semibold rounded-full px-2 bg-blue-50 text-blue-700 border border-blue-200">B2B</span>
        ) : (
          <span className="inline-flex items-center h-5 text-[11px] font-semibold rounded-full px-2 bg-blue-50 text-blue-700 border border-blue-200">B2C</span>
        )}
        <p className="text-[13px] text-gray-400">
          {planType === 'b2b'
            ? '· Only B2B and BOTH content can be added'
            : '· Only B2C and BOTH content can be added'}
        </p>
      </div>

      {/* Assessments section */}
      {showAssessments && (
        <div className="mb-7">
          <div className="flex items-center justify-between mb-3">
            <p className="text-[12px] font-bold text-gray-500 uppercase tracking-[0.06em]">
              Assessments ({assessments.length})
            </p>
             {!isDeleted && (
            <button onClick={() => setAddAssessmentOpen(true)}
              className="flex items-center gap-[6px] bg-blue-600 text-white border-none rounded-[7px] px-[14px] py-2 text-[13px] font-semibold cursor-pointer hover:bg-blue-700">
              + Add Assessment
            </button>
          )}
          </div>
          {assessments.length === 0
          ? <ContentEmptyState message="No assessments added to this plan yet." />
            : <ContentTable columns={assessmentColumns} rows={assessments} isDeleted={isDeleted} onDelete={(item) => setDeleteTarget({ item, type: 'assessment' })} />}
        </div>
      )}

      {/* Courses section */}
      {showCourses && (
        <div>
          <div className="flex items-center justify-between mb-3">
            <p className="text-[12px] font-bold text-gray-500 uppercase tracking-[0.06em]">
              Courses ({courses.length})
            </p>
            {(!isSingleCourse || courses.length === 0) && (!isDeleted) && (
              <button onClick={() => setAddCourseOpen(true)}
                className="flex items-center gap-[6px] bg-blue-600 text-white border-none rounded-[7px] px-[14px] py-2 text-[13px] font-semibold cursor-pointer hover:bg-blue-700">
                + Add Course
              </button>
            )}
        
          </div>
          {courses.length === 0
        ? <ContentEmptyState message="No courses added to this plan yet." />
            : <ContentTable columns={courseColumns} rows={courses} isDeleted={isDeleted} onDelete={(item) => setDeleteTarget({ item, type: 'course' })} />}
        </div>
      )}
      <AddAssessmentModal
        open={addAssessmentOpen}
        onClose={() => setAddAssessmentOpen(false)}
        onAdd={handleAddAssessment}
        existingIds={selectedAssessmentIds}
        fetchFn={assessmentFetchFn}
        tier={plan?.tier}
        assessmentTypes={plan?.assessmentTypes || []}
        audienceIds={audienceIds}
        subscriptionTypeCode={plan?.subscriptionType?.code}
      />

     <AddCourseModal
        open={addCourseOpen}
        onClose={() => setAddCourseOpen(false)}
        onAdd={handleAddCourse}
        existingIds={selectedCourseIds}
        fetchFn={courseFetchFn}
        singleSelect={planType === 'single'}
        planIsFree={plan?.isPaid === 'Free'}
        usedCourseIds={planType === 'b2b' ? [] : usedCourseIds}
        audienceFilter={planType === 'b2b' ? ['B2B', 'BOTH'] : ['B2C', 'BOTH']}
        subscriptionTypeCode={plan?.subscriptionType?.code}
      />

      <DeleteConfirmModal
        open={!!deleteTarget}
        itemName={deleteTarget?.item?.title}
        type={deleteTarget?.type}
        onCancel={() => setDeleteTarget(null)}
        onConfirm={confirmDelete}
      />
    </>
  );
};

export const SubscribersTab = ({ plan }) => {
  const PAGE_SIZE = 10;
  const [subscribers, setSubscribers] = useState([]);
  const [total, setTotal] = useState(0);
  const [activeCount, setActiveCount] = useState(0);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchSubscribers = (p = 0) => {
    if (!plan?.id) return;
    setLoading(true);
    subscriptionServices.getSubscribersByPlanId(plan.id, p, PAGE_SIZE, { source: plan.source })
      .then((res) => {
        if (res.ok) {
          setSubscribers(res.data.rows || []);
          setTotal(res.data.total || 0);
          setActiveCount(res.data.activeCount || 0);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchSubscribers(0);
  }, [plan?.id]);

  const totalPages = Math.ceil(total / PAGE_SIZE);
  const pct = total > 0 ? Math.round((activeCount / total) * 100) : 0;

  return (
    <>
      <div className="flex gap-4 mb-5 flex-wrap">
        <div className="flex-1 bg-white border border-gray-200 rounded-[10px] px-5 py-4">
          <p className="text-[12px] text-gray-400 mb-[6px]">Total subscribers</p>
          <p className="text-[22px] font-bold text-gray-900">{total}</p>
        </div>
        <div className="flex-1 bg-white border border-gray-200 rounded-[10px] px-5 py-4">
          <p className="text-[12px] text-gray-400 mb-1">Active</p>
          <p className="text-[22px] font-bold text-gray-900">{activeCount} of {total} ({pct}%)</p>
        </div>
      </div>

      <div className="bg-white border border-gray-200 rounded-[10px] overflow-hidden">
        <div className="grid grid-cols-4 px-5 py-[11px] bg-gray-50 border-b border-gray-200">
          {['Name', 'Email', 'Valid From', 'Status'].map((h) => (
            <p key={h} className="text-[11px] font-semibold text-gray-500 uppercase tracking-[0.06em]">{h}</p>
          ))}
        </div>

        {loading ? (
          <div className="py-10 text-center text-[13px] text-gray-400">Loading...</div>
        ) : total === 0 ? (
          <div className="py-10 text-center text-[13px] text-gray-400">No subscribers yet</div>
        ) : (
          subscribers.map((s, idx) => (
            <div key={s.id || idx} className="grid grid-cols-4 px-5 py-[13px] hover:bg-gray-50"
              style={{ borderBottom: idx < subscribers.length - 1 ? '1px solid #f3f4f6' : 'none' }}>
              <p className="text-[13px] font-semibold text-gray-900">{s.name?.trim() || '—'}</p>
              <p title={s.email} className="text-[13px] text-gray-700 truncate max-w-[180px]">{s.email}</p>
              <p className="text-[13px] text-gray-500">
                {s.validFrom ? new Date(s.validFrom).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—'}
              </p>
              <span className={`text-[12px] font-semibold ${(s.status === 'ACTIVE' || s.is_free) ? 'text-green-600' : 'text-gray-400'}`}>
                {s.is_free ? 'ACTIVE':s.status}
              </span>
            </div> 
          ))
        )}
      </div>

      {totalPages > 1 && (
        <div className="flex items-center justify-between mt-4 px-1">
          <p className="text-[12px] text-gray-400">
            Showing {page * PAGE_SIZE + 1}–{Math.min((page + 1) * PAGE_SIZE, total)} of {total}
          </p>
          <div className="flex items-center gap-1">
            <button
              onClick={() => { setPage(page - 1); fetchSubscribers(page - 1); }}
              disabled={page === 0}
              className="px-3 py-1 text-[13px] border border-gray-200 rounded-[6px] disabled:opacity-40 hover:bg-gray-50"
            >
              Previous
            </button>

            {Array.from({ length: totalPages }, (_, i) => {
              if ( i === 0 || i === totalPages - 1 || i === page || i === page - 1 || i === page + 1 ) {
                return (
                  <button key={i} onClick={() => { setPage(i); fetchSubscribers(i); }}
                    className={`w-8 h-8 text-[13px] rounded-[6px] border ${page === i
                        ? 'bg-blue-600 text-white border-blue-600'
                        : 'border-gray-200 text-gray-600 hover:bg-gray-50'
                      }`}
                  > {i + 1} </button>
                );
              }
              if (i === page - 2 || i === page + 2) {
                return <span key={i} className="text-[13px] text-gray-400 px-1">...</span>;
              }
              return null;
            })}
            <button
              onClick={() => { setPage(page + 1); fetchSubscribers(page + 1); }}
              disabled={page >= totalPages - 1}
              className="px-3 py-1 text-[13px] border border-gray-200 rounded-[6px] disabled:opacity-40 hover:bg-gray-50"
            >
              Next
            </button>
          </div>
        </div>
      )}
    </>
  );
};

const ACTION_STYLES = {
  'Content added': { bg: 'bg-violet-50 text-violet-700 border-violet-200' },
  'Published': { bg: 'bg-green-100 text-green-800 border-green-300' },
  'Created': { bg: 'bg-blue-50 text-blue-700 border-blue-200' },
  'Draft': { bg: 'bg-amber-50 text-amber-700 border-amber-300' },
  'Updated': { bg: 'bg-amber-50 text-amber-800 border-amber-300' },
};

const ActionChip = ({ action }) => {
  const s = ACTION_STYLES[action] || ACTION_STYLES.Updated;
  return (
    <span className={`inline-flex items-center h-[22px] text-[11px] font-semibold rounded-full px-2 border flex-shrink-0 ${s.bg}`}>
      {action}
    </span>
  );
};

export const AuditLogTab = ({ plan }) => {
  const logs = plan?.auditLogs || [];

  const demoLogs = [
    { action: 'Content added', actor: 'admin@keyskillset.com', meta: 'count: 1 · content_type: ASSESSMENT', date: '25 Mar 2026' },
    { action: 'Published', actor: 'admin@keyskillset.com', meta: `stripe_product_id: ${plan?.stripeProductId || 'stripe_prod_DEMO_7151a03c'}`, date: '1 Feb 2026' },
    { action: 'Created', actor: 'admin@keyskillset.com', meta: null, date: '31 Jan 2026' },
  ];

  const displayLogs = logs.length > 0 ? logs : demoLogs;

  if (displayLogs.length === 0) {
    return (
      <div className="flex justify-center py-[60px]">
        <p className="text-[13px] text-gray-400">No changes recorded yet.</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-[10px]">
      {displayLogs.map((log, idx) => (
       <div key={`${log.action}-${log.date}-${idx}`} className="flex items-start gap-[14px] bg-white border border-gray-200 rounded-[10px] px-5 py-4">
          <ActionChip action={log.action} />
          <div className="flex-1">
            <p className="text-[13px] font-medium text-gray-900">{log.actor}</p>
            {log.meta && <p className="text-[12px] text-gray-400 mt-[2px]">{log.meta}</p>}
          </div>
          <p className="text-[12px] text-gray-400 flex-shrink-0">{log.date}</p>
        </div>
      ))}
    </div>
  );
};